// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;Great are the wonders you have done, O Lord my God.<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;How great your designs for us!&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;There is none that can be compared with you.<br> </p> </div></div>";
// Exports
module.exports = code;